import store from '../..';
import { alphabeticSort } from '../helpers';

export function setFilterOptions(payload) {
  const options = buildFilterOptions(payload);
  store.commit('filters/setGroupsFilterOptions', options);
}
export function buildFilterOptions(payload) {
  const cityList = new Set(
    store.getters['filters/getGroupsFilterOptions'].cities,
  );
  const interfaceList = new Set(
    store.getters['filters/getGroupsFilterOptions'].interfaces,
  );
  const adScheduleList = new Set(
    store.getters['filters/getGroupsFilterOptions'].adSchedules,
  );
  payload.reduce((a, c) => {
    c.address && c.address.city && cityList.add(c.address.city);
    c.interface && interfaceList.add(c.interface);
    c.ad_schedule && adScheduleList.add(c.ad_schedule);
  }, []);
  return {
    interfaces: [...interfaceList].sort(alphabeticSort),
    cities: [...cityList].sort(alphabeticSort),
    adSchedules: [...adScheduleList].sort(alphabeticSort),
    active: ['Active', 'Inactive'],
  };
}
